export default {
      id: "header_instagram-usage",
      viewBox: "0 0 23.13 23.22",
      url: "../dist/images/" + "sprite.svg#header_instagram-usage",
      toString: function () {
        return this.url;
      }
    }